import type { EventRunnerType, EventType } from "app/types/eventType";
import React from "react";
import AsianOdds from "../../../../../AsianOdds/AsianOdds";

type RunnerElementProps = {
  runner: EventRunnerType;
  event: EventType;
  highestOdds: number | any;
  addBetSlip: (...args: Array<any>) => any;
  marketType: string;
  props: any;
};

const RunnerElement: React.FC<RunnerElementProps> = ({
  runner,
  event,
  highestOdds,
  addBetSlip,
  marketType,
  props,
}) => {
  return (
    <div className={`asian-1x2-${runner.side}`} key={runner.id}>
      <AsianOdds
        className={event.inRunning ? "asian-odds-live" : ""}
        odds={highestOdds}
        onClickPrice={() => addBetSlip(runner, props, event)}
        runner={runner}
        marketType={marketType}
      />
    </div>
  );
};

export default RunnerElement;
